import templateUrl from './federal-w4-signature-form.component.html';

export const FederalW4SignatureFormComponent = {
    templateUrl,
    controller: FederalW4SignatureFormController,
    controllerAs: "vm",
    bindings: {
        employee: "<",
        employeeProfile: "<",
        profile: "<",
        employeeBankInfo: "<",
        provinces: "<",
        application: "<",
        genderOptions: "<",
    }
};

function FederalW4SignatureFormController(utilityService,$state, $q, employeeService
    , onboardingDocumentService, onboardingDocumentViewService) {
    'ngInject';
    const vm = this;
    vm.state = {
        view: 'FederalW4Signature'
    };
    vm.onShowFederalW4 = onShowFederalW4;
    vm.checkAndShowNext = checkAndShowNext;
    vm.isStateW4Required = false;

    //vm.isNy = false;
    //vm.isAl = false;
    //vm.isAz = false;
    //vm.isAr = false;
    vm.empState = '';

    vm.$onInit = function () {
        vm.isSiteAdmin = vm.employee.IsSiteAdmin;
        vm.userProfile = vm.profile;
        if (vm.employeeBankInfo.StateAbbrevation !== '') {
            vm.empState = vm.employeeBankInfo.StateAbbrevation;
        } else {
            vm.empState = vm.employee.State.Abbreviation;
        }
        utilityService.hideLoading();
    }

    function onShowFederalW4() {
        return $state.go('onboarding-document.federalW4');
        //return $state.go('onboarding-document.provinceW4');
    }


    function checkAndShowNext() {
        utilityService.showLoading();
        return $state.go('onboarding-document.provinceW4');
    }
}
